import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
  useGameHeader,
  useScrollGameContentToTopOnMount,
  HeaderBackButton,
} from '../../components/layout';
import { TermsPage } from '../../features/terms/terms-page';

const TermsRouteComponent = () => {
  const navigate = useNavigate();

  useScrollGameContentToTopOnMount();

  useGameHeader({
    left: <HeaderBackButton onClick={() => void navigate({ to: '/lobby' })} />,
    center: <span className="font-heading text-sm font-semibold">Terms &amp; Conditions</span>,
  });

  return <TermsPage />;
};

export const Route = createFileRoute('/_authenticated/terms')({
  component: TermsRouteComponent,
});
